import { Link } from 'react-router-dom';
import HeroCarousel from './components/HeroCarousel';
import CategoryGrid from './components/CategoryGrid';
import HotGrid from './components/HotGrid';
import LatestUpdates from './components/LatestUpdates';
import { useSEO } from '@/hooks/useSEO';

const stats = [
  { icon: 'ri-book-2-line', value: '500+', label: '收录双女主韩漫' },
  { icon: 'ri-layout-grid-line', value: '7', label: '精选题材分类' },
  { icon: 'ri-refresh-line', value: '30+', label: '每日更新章节' },
  { icon: 'ri-eye-line', value: '3000万+', label: '累计在线阅读' },
];

export default function Home() {
  useSEO({
    title: '韩漫免费观看在线阅读漫画双女主-最新热门双女主韩漫全集',
    description:
      '韩漫免费观看在线阅读漫画双女主网站，收录最新热门双女主韩漫作品，提供丰富漫画分类，方便用户在线观看各种双女主题材的精彩韩漫内容。',
    keywords: '韩漫,双女主,漫画,在线阅读,免费观看,韩漫漫画,双女主漫画,漫画全集',
  });

  return (
    <>
      <HeroCarousel />

      <section className="border-b border-background-200 bg-background-50">
        <div className="mx-auto w-full px-4 md:px-6">
          <div className="grid grid-cols-2 divide-background-200 md:grid-cols-4 md:divide-x">
            {stats.map((stat) => (
              <div key={stat.label} className="flex items-center gap-3 px-2 py-6 md:justify-center">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${stat.icon} text-xl`}></i>
                </span>
                <div>
                  <p className="text-xl font-bold text-foreground-950">{stat.value}</p>
                  <p className="text-xs text-foreground-500">{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CategoryGrid />
      <HotGrid />
      <LatestUpdates />

      <section className="bg-background-100 py-12 md:py-16">
        <div className="mx-auto w-full px-4 md:px-6">
          <div className="grid grid-cols-1 items-center gap-8 overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:grid-cols-2">
            <div className="p-6 md:p-10">
              <span className="mb-3 inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
                <i className="ri-information-line"></i>
                关于本站
              </span>
              <h1 className="text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
                韩漫免费观看在线阅读漫画双女主
              </h1>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                我们是一个专注「双女主」题材的韩漫在线阅读平台，致力于收录最新、最热门的双女主韩漫作品。
                通过清晰的题材分类、便捷的搜索与筛选，以及宽松舒适的阅读排版，帮助每一位读者快速找到心仪的作品，
                愉快地追漫与探索剧情。
              </p>
              <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {[
                  { icon: 'ri-shield-check-line', text: '全部作品免费在线阅读' },
                  { icon: 'ri-grid-line', text: '多维分类与关键词搜索' },
                  { icon: 'ri-heart-3-line', text: '一键收藏常看的作品' },
                  { icon: 'ri-smartphone-line', text: '手机端同样流畅浏览' },
                ].map((item) => (
                  <li key={item.text} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className={`${item.icon} text-accent-600`}></i>
                    {item.text}
                  </li>
                ))}
              </ul>
              <div className="mt-8 flex flex-wrap gap-3">
                <Link
                  to="/about"
                  className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-emotion-happy-line"></i>
                  了解更多
                </Link>
                <Link
                  to="/category/romance"
                  className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  <i className="ri-heart-3-line"></i>
                  看恋爱分类
                </Link>
              </div>
            </div>
            <div className="h-64 w-full lg:h-full lg:min-h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20a%20cozy%20reading%20corner%20with%20two%20young%20women%20enjoying%20comics%20and%20warm%20drinks%2C%20soft%20warm%20coral%20and%20teal%20tones%2C%20clean%20bright%20background%2C%20gentle%20natural%20light%2C%20editorial%20lifestyle%20illustration%2C%20harmonious%20composition%2C%20high%20detail&width=900&height=1000&seq=home-about-01&orientation=portrait"
                alt="双女主韩漫在线阅读平台介绍"
                title="双女主韩漫在线阅读平台"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}